import { render, staticRenderFns } from "./observation.vue?vue&type=template&id=7243829a&scoped=true&"
import script from "./observation.vue?vue&type=script&lang=js&"
export * from "./observation.vue?vue&type=script&lang=js&"
import style0 from "./css/index.css?vue&type=style&index=0&id=7243829a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7243829a",
  null
  
)

export default component.exports